export default __webpack_public_path__ + "static/media/Sabroe-compressor.5dacaec0.jpg";